import request from '../utils/request';
import requestV2 from '../utils/requestV2';



// 获取素材列表
export const getMaterials = (params) => {
  return requestV2.get('/system/materials', { params });
};
// export const getMaterials = (params) => {
//   return request.get('/materials', { params });
// };

// 获取单个素材
export const getMaterial = (id) => {
  return request.get(`/materials/${id}`);
};

// 添加素材
export const addMaterial = (data) => {
  return request.post('/materials', data);
};

// 更新素材
export const updateMaterial = (id, data) => {
  return request.put(`/materials/${id}`, data);
};

// 删除素材
export const deleteMaterial = (id) => {
  return request.delete(`/materials/${id}`);
};

// 获取素材分类
// export const getCategories = () => {
//   return request.get('/materials/categories');
// };
export const getCategories = () => {
  return requestV2.get('/system/materials/getAllCategories');
};

export const saveTags = (data) => {
  return requestV2.post('/system/materials/materialsToTag', data);
};

export const saveTagsOne = (data) => {
  return requestV2.post('/system/materials/materialsToTagOne', data);
};

// 添加分类
export const addCategory = (data) => {
  return request.post('/materials/categories', data);
};

// 更新分类
export const updateCategory = (id, data) => {
  return request.put(`/materials/categories/${id}`, data);
};

// 删除分类
export const deleteCategory = (id) => {
  return request.delete(`/materials/categories/${id}`);
};

// 批量删除素材
export const batchDeleteMaterials = (ids) => {
  return request.post('/materials/batch-delete', { ids });
};

// 批量更新素材分类
export const batchUpdateMaterialCategory = (ids, categoryId) => {
  return request.post('/materials/batch-update-category', { ids, categoryId });
};

// 记录素材查看
export const recordView = (id) => {
  // return request.post(`/materials/${id}/view`);
};

// 为了保持向后兼容，提供MaterialService对象导出
export const MaterialService = {
  getList: getMaterials,
  getDetail: getMaterial,
  recordView,
  // 添加其他可能使用的方法
  add: addMaterial,
  update: updateMaterial,
  delete: deleteMaterial,
  getCategories,
};

// 其他素材相关API... 